module.exports = __webpack_public_path__ + "static/img/pro1.99d1ca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/pro1.png
// module id = +B5g
// module chunks = 0